import {
  Box,
  Button,
  CloseIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from "@carrotfertility/carotene-core"
import { Form, FormButton, FormTextField } from "@carrotfertility/carotene-core-x"
import { useCurrentUser } from "components/context/user/UserContext"
import { IlloPaperAirplaneCircle } from "components/views/atoms/Illustrations"
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { useHistory } from "react-router-dom"
import { adminCarrotClient } from "utils/CarrotClient"

function SaveCompleteView(): JSX.Element {
  const history = useHistory()

  return (
    <Dialog open={true}>
      <Box justifyContent="center" display="flex" paddingY={(theme) => theme.spacing(theme.tokens.spacing.lg)}>
        <IlloPaperAirplaneCircle />
      </Box>
      <DialogTitle>
        <FormattedMessage defaultMessage="Message received!" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage defaultMessage="Thanks for telling us about your experience." />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => history.replace("/")}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export function JourneyCompleteNoteModal(): JSX.Element {
  const history = useHistory()
  const { getFirstName } = useCurrentUser()
  const [showCompleteView, setShowCompleteView] = React.useState(false)
  const intl = useIntl()
  const memberNoteLabel = intl.formatMessage({ defaultMessage: "message" })
  if (showCompleteView) {
    return <SaveCompleteView />
  }

  const submitForm = async (formValues: { memberNote?: string }) => {
    try {
      await adminCarrotClient.carrotPlanJourneyCompleteMemberNote(formValues?.memberNote)
      setShowCompleteView(true)
    } catch (error) {
      reportError(error)
    }
  }
  return (
    <Dialog onClose={() => history.replace("/")} open={true} maxWidth="md">
      <Box display="flex" justifyContent="flex-end">
        <IconButton aria-label={intl.formatMessage({ defaultMessage: "close" })} onClick={() => history.replace("/")}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Form onSubmit={(form) => submitForm(form)}>
        <DialogTitle>
          <FormattedMessage defaultMessage="Thanks, {memberFirstName}" values={{ memberFirstName: getFirstName() }} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <FormattedMessage defaultMessage="If you'd like, tell us why your journey with Carrot is complete. Were we able to help you with your goals?" />
          </DialogContentText>
          <FormTextField multiline minRows={2} name="memberNote" label={memberNoteLabel} aria-label={memberNoteLabel} />
        </DialogContent>
        <DialogActions>
          <FormButton type="submit">
            <FormattedMessage defaultMessage="Send" />
          </FormButton>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
